/**
 * @fileoverview gRPC-Web generated client stub for dash.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v0.0.0
// source: dash/v1/area.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var dash_v1_models_pb = require('../../dash/v1/models_pb.js')

var types_v1_status_pb = require('../../types/v1/status_pb.js')
const proto = {};
proto.dash = {};
proto.dash.v1 = require('./area_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.dash.v1.AreaServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.dash.v1.AreaServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dash.v1.GetAreaRequest,
 *   !proto.dash.v1.GetAreaResponse>}
 */
const methodDescriptor_AreaService_GetArea = new grpc.web.MethodDescriptor(
  '/dash.v1.AreaService/GetArea',
  grpc.web.MethodType.UNARY,
  proto.dash.v1.GetAreaRequest,
  proto.dash.v1.GetAreaResponse,
  /**
   * @param {!proto.dash.v1.GetAreaRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dash.v1.GetAreaResponse.deserializeBinary
);


/**
 * @param {!proto.dash.v1.GetAreaRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dash.v1.GetAreaResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dash.v1.GetAreaResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dash.v1.AreaServiceClient.prototype.getArea =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dash.v1.AreaService/GetArea',
      request,
      metadata || {},
      methodDescriptor_AreaService_GetArea,
      callback);
};


/**
 * @param {!proto.dash.v1.GetAreaRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dash.v1.GetAreaResponse>}
 *     Promise that resolves to the response
 */
proto.dash.v1.AreaServicePromiseClient.prototype.getArea =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dash.v1.AreaService/GetArea',
      request,
      metadata || {},
      methodDescriptor_AreaService_GetArea);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dash.v1.PutAreaRequest,
 *   !proto.dash.v1.PutAreaResponse>}
 */
const methodDescriptor_AreaService_PutArea = new grpc.web.MethodDescriptor(
  '/dash.v1.AreaService/PutArea',
  grpc.web.MethodType.UNARY,
  proto.dash.v1.PutAreaRequest,
  proto.dash.v1.PutAreaResponse,
  /**
   * @param {!proto.dash.v1.PutAreaRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dash.v1.PutAreaResponse.deserializeBinary
);


/**
 * @param {!proto.dash.v1.PutAreaRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dash.v1.PutAreaResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dash.v1.PutAreaResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dash.v1.AreaServiceClient.prototype.putArea =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dash.v1.AreaService/PutArea',
      request,
      metadata || {},
      methodDescriptor_AreaService_PutArea,
      callback);
};


/**
 * @param {!proto.dash.v1.PutAreaRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dash.v1.PutAreaResponse>}
 *     Promise that resolves to the response
 */
proto.dash.v1.AreaServicePromiseClient.prototype.putArea =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dash.v1.AreaService/PutArea',
      request,
      metadata || {},
      methodDescriptor_AreaService_PutArea);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dash.v1.ListAreasRequest,
 *   !proto.dash.v1.ListAreasResponse>}
 */
const methodDescriptor_AreaService_ListAreas = new grpc.web.MethodDescriptor(
  '/dash.v1.AreaService/ListAreas',
  grpc.web.MethodType.UNARY,
  proto.dash.v1.ListAreasRequest,
  proto.dash.v1.ListAreasResponse,
  /**
   * @param {!proto.dash.v1.ListAreasRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dash.v1.ListAreasResponse.deserializeBinary
);


/**
 * @param {!proto.dash.v1.ListAreasRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dash.v1.ListAreasResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dash.v1.ListAreasResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dash.v1.AreaServiceClient.prototype.listAreas =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dash.v1.AreaService/ListAreas',
      request,
      metadata || {},
      methodDescriptor_AreaService_ListAreas,
      callback);
};


/**
 * @param {!proto.dash.v1.ListAreasRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dash.v1.ListAreasResponse>}
 *     Promise that resolves to the response
 */
proto.dash.v1.AreaServicePromiseClient.prototype.listAreas =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dash.v1.AreaService/ListAreas',
      request,
      metadata || {},
      methodDescriptor_AreaService_ListAreas);
};


module.exports = proto.dash.v1;

